<template>
<div class="py-6 flex flex-col justify-center sm:py-12">
  <div class="relative py-3 sm:max-w-xl sm:mx-auto">
    <div :class="[
      'absolute inset-0 bg-gradient-to-r',
      backgroundColorClass,
      'shadow-lg transform -skew-y-6 sm:skew-y-0',
      rotateClass,'rounded-3xl transition-colors transition-transform duration-500 ease-in-out']"></div>
    <div class="relative px-4 bg-white dark:bg-gray-800 shadow-lg rounded-3xl transition-colors duration-500 ease-in-out">
      <div class="max-w-md mx-auto">
        <div class="divide-y divide-gray-200">
          <div class="py-8 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7 ">
            <p class="dark:text-gray-400"><b>{{title}}</b></p>
            <ul class="list-disc space-y-2">
              <li class="flex items-start" v-for="(i,n) in list" :key="n">
                <span class="h-6 flex items-center sm:h-7 dark:text-gray-500">
                  <svg class="flex-shrink-0 h-5 w-5 text-cyan-500" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                  </svg>
                </span>
                <p class="ml-2 dark:text-gray-300">
                  {{i}}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
    name: 'ListComponent',
    props: {
        list: {
            default: ()=>([]),
            type: Array
        },
        title: {
            default: '',
            type:String
        },
        backgroundColorClass: {
            default: '',
            type:String
        },
        rotateClass: {
            default: '',
            type:String
        }
    }
}
</script>

<style>

</style>